import { Injectable, PLATFORM_ID, Inject, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { catchError, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { IClientContextBase } from './interfaces/client-context-base';
import { IResponse } from '../http/interfaces/response.interface';
import { IBaseServerConfiguration } from '../server-configuration/interfaces/base-server-configuration.interface';
import { TransferState, makeStateKey } from '@angular/platform-browser';
import { REQUEST } from '@nguniversal/express-engine/tokens';

@Injectable({
  providedIn: 'root'
})
export class InitializerService {

  private appConfigs: IBaseServerConfiguration;
  private clientContext: IClientContextBase;
  private isBrowser: boolean;
  // tslint:disable-next-line:max-line-length
  constructor(
    private httpSvc: HttpClient,
    @Inject(PLATFORM_ID) private platformId: any,
    @Inject('CONFIG_URL') private configUrl: string,
    @Inject('CLIENT_CONTEXT_URL') private clientContextUrl: string,
    private transferState: TransferState,
    @Optional()
    @Inject(REQUEST)
    private request: any
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  public getAppConfigs<T extends IBaseServerConfiguration>(): T {
    return this.appConfigs as T;
  }

  public getClientContext<T extends IClientContextBase>(): T {
    return this.clientContext as T;
  }

  public init(serverClientContextLoader: (request: any) => IClientContextBase): Promise<void> {
    const promise = new Promise<void>((resolve, reject) => {
      const clientContextBaseKey = makeStateKey<IClientContextBase>('ClientContextBase');

      this.loadConfigs().subscribe(res => {
        if (!this.isBrowser) {
          this.clientContext = serverClientContextLoader(this.request);
          this.transferState.set(clientContextBaseKey, this.clientContext);
          resolve();
        }
        else {
          const clientContext = this.transferState.get<IClientContextBase>(clientContextBaseKey, null);
          if (clientContext) {
            this.clientContext = clientContext;
            resolve();
          } else {
            this.loadClientContext(this.appConfigs.apiUrl).subscribe(() => {
              resolve();
            })
          }
        }
      })
    });
    return promise;
  }

  private loadConfigs() {
    return this.httpSvc
      .get<IBaseServerConfiguration>(this.configUrl)
      .pipe(
        catchError(
          (error: any): any => {
            console.log(
              `Configuration file "${this.configUrl.substring(
                this.configUrl.lastIndexOf('/') + 1
              )}" could not be read`
            );
            return Observable.throw(error || 'Server error');
          }
        ),
        (tap(res => {
          this.appConfigs = {...res as IBaseServerConfiguration};
          // if (!this.isBrowser) {
          //   try {
          //     //replace https to http only in server.
          //     this.appConfigs.apiUrl = this.appConfigs.apiUrl.replace(
          //       'https',
          //       'http'
          //     );
          //   } catch (error) {
          //     console.log(
          //       'error in ServerConfigurationService: ' +
          //       error.toString()
          //     );
          //   }
          // }
        }))
      );
  }

  private loadClientContext(apiUrl: string) {
    return this.httpSvc.get<IResponse<IClientContextBase>>(`${apiUrl}${this.clientContextUrl}`).pipe(
      catchError(
        (error: any): any => {
          console.log(
            `failed to retrieve client context from ${apiUrl}`
          );
          return Observable.throw(error || 'Server error');
        }
      ),
      (tap(res => {
        this.clientContext = (res as any).Result as IClientContextBase;
      })))
  }
}
